import { CUSTOM_DOMAINS_SETTINGS_API } from 'modules/profile/custom-domains-settings/api/custom-domain-api'
import { CustomDomainsLoginPageApiInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useCustomDomainPageApi = (domainId: number) => {
  const { fetcher: postFetcher } = useFetch<
    RequestMethodsEnum.post,
    CustomDomainsLoginPageApiInterface
  >({
    method: RequestMethodsEnum.post,
  })

  const getLoginPageUrl = () =>
    postFetcher(`${CUSTOM_DOMAINS_SETTINGS_API}/login-page-url/${domainId}`)
  const get404PageUrl = () =>
    postFetcher(`${CUSTOM_DOMAINS_SETTINGS_API}/not-found-page-url/${domainId}`)

  return { getLoginPageUrl, get404PageUrl }
}
